<template>
  <div
    class="create-pin md:tw-w-[610px] tw-w-11/12 tw-flex tw-items-center tw-pb-8 tw-rounded-[10px] md:tw-h-[532px]"
  >
    <div class="tw-max-w-[365px] tw-mx-auto">
      <OnboardingHeader headerText="Set your 4-digit PIN" />
      <OnboardingSubHeader
        subHeaderText="You’ll use this PIN for confirming your transactions"
      />
      <CreatePinForm class="tw-w-full" />
    </div>
  </div>
</template>

<script>
  import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
  import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
  import CreatePinForm from "@/components/onboarding/forms/CreatePinForm.vue";
  import { getItem } from "@/utils/storage.js";

  export default {
    name: "CreatePin",

    components: { OnboardingHeader, OnboardingSubHeader, CreatePinForm },
    created() {
      const id = getItem("org_details")?._id;
      if (!id) {
        this.$router.push({ name: "SignIn" });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .create-pin {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  }
</style>
